/* Compact Work date pickers fill their form locally; Save resolves tokens server-side. */
(function () {
    function dateInWorkTimezone(form) {
        var now = new Date();
        var values = {};
        if (form.dataset.workDateTimezone && window.Intl && Intl.DateTimeFormat) {
            Intl.DateTimeFormat('en-CA', {
                timeZone: form.dataset.workDateTimezone,
                year: 'numeric', month: '2-digit', day: '2-digit'
            }).formatToParts(now).forEach(function (part) {
                if (part.type !== 'literal') values[part.type] = Number(part.value);
            });
        }
        var year = values.year || now.getFullYear();
        var month = values.month || now.getMonth() + 1;
        var day = values.day || now.getDate();
        return new Date(Date.UTC(year, month - 1, day, 12));
    }

    function localDate(token, form) {
        // Work from the server's calendar day, then use UTC arithmetic so a
        // client in another timezone previews the date the server will save.
        var date = dateInWorkTimezone(form);
        var offsets = {today: 0, tomorrow: 1, plus_3: 3, plus_7: 7, in_3_days: 3};
        if (Object.prototype.hasOwnProperty.call(offsets, token)) {
            date.setUTCDate(date.getUTCDate() + offsets[token]);
        } else {
            // "Next" is the following Monday-based calendar week.
            var weekday = (date.getUTCDay() + 6) % 7;
            date.setUTCDate(date.getUTCDate() + 7 - weekday + (token === 'next_friday' ? 4 : 0));
        }
        return date.getUTCFullYear() + '-' + String(date.getUTCMonth() + 1).padStart(2, '0') + '-' +
            String(date.getUTCDate()).padStart(2, '0');
    }

    function setQuickState(form, active) {
        Array.from(form.querySelectorAll('[data-work-quick-date]')).forEach(function (chip) {
            var selected = chip.getAttribute('data-work-quick-date') === active;
            chip.classList.toggle('chip-primary', selected);
            chip.classList.toggle('chip-muted', !selected);
        });
    }

    document.addEventListener('click', function (event) {
        var chip = event.target.closest('[data-work-quick-date]');
        if (!chip) return;
        var form = chip.closest('form');
        var input = form && form.querySelector('[data-work-quick-date-input]');
        var token = form && form.querySelector('[data-work-quick-date-token]');
        if (!form || !input || !token) return;

        var choice = chip.getAttribute('data-work-quick-date');
        if (choice === 'clear') {
            input.value = '';
            token.value = 'clear';
            setQuickState(form, '');
            return;
        }
        input.value = localDate(choice, form);
        token.value = choice;
        setQuickState(form, choice);
    });

    function clearQuickToken(event) {
        var input = event.target.closest('[data-work-quick-date-input]');
        if (!input) return;
        var form = input.closest('form');
        var token = form && form.querySelector('[data-work-quick-date-token]');
        if (!token) return;
        token.value = '';
        setQuickState(form, '');
    }
    document.addEventListener('input', clearQuickToken);
    document.addEventListener('change', clearQuickToken);

    document.addEventListener('click', function (event) {
        var cancel = event.target.closest('[data-work-schedule-cancel]');
        if (!cancel) return;
        var form = cancel.closest('form');
        if (!form) return;
        form.reset();
        var textarea = form.querySelector('[data-work-next-action]');
        if (textarea) textarea.dispatchEvent(new Event('input', {bubbles: true}));
        var original = form.querySelector('[data-work-quick-date-original-active]');
        setQuickState(form, original ? original.getAttribute('data-work-quick-date') : '');
    });

    document.addEventListener('click', function (event) {
        var clear = event.target.closest('[data-work-schedule-clear-action]');
        if (!clear) return;
        var form = clear.closest('form');
        var textarea = form && form.querySelector('[data-work-next-action]');
        if (!textarea) return;
        textarea.value = '';
        textarea.dispatchEvent(new Event('input', {bubbles: true}));
    });

    // Clear: Waiting on, in the next-action dropdown; Save then clears it on the task.
    document.addEventListener('click', function (event) {
        var clear = event.target.closest('[data-work-schedule-clear-waiting]');
        if (!clear) return;
        var input = clear.closest('form') && clear.closest('form').querySelector('[name="waiting_on"]');
        if (!input) return;
        input.value = '';
        input.focus();
    });
}());
